var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.isWX != 0)?_c('h5-header',{attrs:{"header-msg":_vm.headerMsg}}):_vm._e(),_c('div',{staticClass:"cont",domProps:{"innerHTML":_vm._s(_vm.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }